import { render } from "./add-reserve-dialog.vue?vue&type=template&id=6127bb3a&scoped=true"
import script from "./add-reserve-dialog.vue?vue&type=script&lang=js"
export * from "./add-reserve-dialog.vue?vue&type=script&lang=js"

import "./add-reserve-dialog.vue?vue&type=style&index=0&id=6127bb3a&scoped=true&lang=less"

import exportComponent from "/home/www/jenkins/jenkins_home/workspace/yizhige_production/yizhige_admin_pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6127bb3a"]])

export default __exports__